import { getHorizontalAlignment } from "../style/legend/getHorizontalAlignment.ts";
import { getVerticalAlignment } from "../style/legend/getVerticalAlignment.ts";
import type { ChartStyleSettings } from "../../../../../../../../api/types/svTypes.ts";

export function getBasicLegend(settingsArea: ChartStyleSettings) {
  return {
    visible: settingsArea.legend?.visible !== false,
    horizontalAlignment: getHorizontalAlignment(settingsArea),
    verticalAlignment: getVerticalAlignment(settingsArea),
    title: settingsArea.legend?.title,
    font: { family: "Roboto" },
  };
}
